import { AxiosError } from 'axios';
import { createSelector } from 'reselect';
import { convertTreeToFlat } from 'utils/object';
import { IHierarchyLocation } from './types';

export const selectLoadedState = (state: { loaded: boolean }) => state.loaded;
export const selectLocations = (state: { locationsHierarchy: IHierarchyLocation[] }) =>
  state.locationsHierarchy;
export const selectSyncError = (state: { error: AxiosError | null }) => state.error;
export const selectSyncState = (state: { syncing: boolean }) => state.syncing;

export const selectIndexedLocations = createSelector(
  selectLocations,
  (locations: IHierarchyLocation[]) => convertTreeToFlat<IHierarchyLocation>(locations, 'value')
);
export const selectLocation = createSelector(
  [selectIndexedLocations, (_: any, id: any) => id],
  (indexedLocations, id) => indexedLocations[id]
);
